import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import Path from "@/lib/common/path";
import Config from "@/config/config";

/**
 * 瑞幸咖啡 面试灰度接口
 */
export default class Interview extends Model {
  // 列表
  static getList(req: Req): Promise<any> {
    const autoHandleError = true;
    return request.post(
      Path.join(Config.apiUrl, "/aiExam/mokaExamRedirectConfig/list"),
      { ...req },
      autoHandleError
    );
  }

  // 保存
  static save(params: object): Promise<any> {
    const autoHandleError = true;
    return request.post(
      Path.join(Config.apiUrl, "/aiExam/mokaExamRedirectConfig/save"),
      { ...params },
      autoHandleError
    );
  }

  // 修改
  static changeStatus(req: TableItem): Promise<any> {
    const autoHandleError = true;
    return request.post(
      Path.join(Config.apiUrl, "/aiExam/mokaExamRedirectConfig/changeStatus"),
      { ...req },
      autoHandleError
    );
  }
}
export interface Sort {
  configId: Number;
  taskNameLike: string;
  originExamId: string;
  targetExamId: string;
  statusList: number[] | undefined;
  returnAll: boolean; // 是否返回全量忽略分页
}
export interface Req {
  features: Sort;
  page: number;
  pageSize: number;
}

// 弹窗中字段类型
export interface FormFields {
  configId: number;
  taskName: string; // 任务名称
  originExamId: string; // 原面试id
  targetExamId: string; // 灰度面试id
  matchList: string[][]; // 灰度范围 [[], []]
  range: ""; // 灰度范围 string
}

// 表格中每行数据的类型
export interface TableItem extends FormFields {
  configId: number; //任务ID
  date: string; // 日期
  account: string; // 账户
  isClose: number; // 是否开启
}

// 弹窗的类型：新增 || 编辑
export const ADD = "add";
export const EDIT = "edit";
